import { Static, String } from "runtypes";

export const WorkbenchTabGroupId = String.withBrand("WorkbenchTabGroupId");
export type WorkbenchTabGroupId = Static<typeof WorkbenchTabGroupId>;

export type WorkbenchTabGroup<T extends WorkbenchTab = WorkbenchTab> = {
  id: WorkbenchTabGroupId;
  /** The tabs in this group. */
  tabs: T[];
  /** The currently focused tab within this group. */
  currentTabId: WorkbenchTabId;
};

export const WorkbenchTabId = String.withBrand("WorkbenchTabId");
export type WorkbenchTabId = Static<typeof WorkbenchTabId>;

export interface WorkbenchTab {
  id: WorkbenchTabId;
  /** If true, this tab will be closed if any
   * other tab within this group becomes focused. */
  isPreview?: boolean;
}
